import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import cognito from './cognito'
import axios from 'axios'

import { postRequest } from "./utils/api";
import { postKeyValueRequest } from "./utils/api";
import { putRequest } from "./utils/api";
import { deleteRequest } from "./utils/api";
import { getRequest } from "./utils/api";
import { getStreamRequest } from "./utils/api";

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import moment from "moment";

import $ from "jquery";
Vue.prototype.$ = $;

Vue.prototype.postRequest = postRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.getStreamRequest = getStreamRequest;

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(VueToast, {
  position: 'top',
  duration: 5000
})

Vue.filter("dateString", function (value, format = "YYYY/MM/DD") {
  if (value) {
    return moment(value).format(format);
  } else {
    return ''
  }
});

Vue.filter("numberString", function (value) {
  if (value) {
    return new Intl.NumberFormat('ja-JP').format(value);
  } else {
    return ''
  }
});

// 単項目チェックルール
Vue.mixin({
  data() {
    return {
      GlobalRules: {
        // 必須チェック
        required: value => !!value || '必須入力です。',
        // 桁数チェック
        counter_1: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 1 || '1桁で入力してください。'
        },
        counter_4: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 4 || '4桁以内で入力してください。'
        },
        counter_5: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 5 || '5桁以内で入力してください。'
        },
        counter_10: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 10 || '10桁以内で入力してください。'
        },
        counter_13: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 13 || '13桁以内で入力してください。'
        },
        counter_15: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 15 || '15桁以内で入力してください。'
        },
        counter_20: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 20 || '20桁以内で入力してください。'
        },
        counter_30: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 30 || '30桁以内で入力してください。'
        },
        counter_50: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 50 || '50桁以内で入力してください。'
        },
        counter_64: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 64 || '64桁以内で入力してください。'
        },
        counter_128: value => {
          if (!value) {
            return true;
          }
          return value && value.length <= 128 || '128桁以内で入力してください。'
        },
        more_8: value => {
          if (!value) {
            return true;
          }
          return value && value.length >= 8 || '8桁以上で入力してください。'
        },
        // eMailアドレス形式チェック
        email: value => {
          if (!value) {
            return true;
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'メールアドレス形式で入力してください。'
        },
        //認証コードチェック
        authcode: value => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]{6}\d*|0)$/
          return pattern.test(value) || '認証コードを入力してください。'
        },
        //社員番号チェック
        employee_id: value => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]\d*|0)$/
          return pattern.test(value) || '社員番号を入力してください。'
        },
        //パスワード形式チェック
        hanSpec: value => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z_?!#$%&]*$/
          return pattern.test(value) || '使用できない文字です。'
        },
        required_lowercase: value => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[a-z])/
          return pattern.test(value) || '小文字を含めてください。'
        },
        required_uppercase: value => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[A-Z])/
          return pattern.test(value) || '大文字を含めてください。'
        },
        required_number: value => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[0-9])/
          return pattern.test(value) || '数字を含めてください。'
        },
        required_spec: value => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[_?!#$%&])/
          return pattern.test(value) || '特殊文字を含めてください。'
        },
        // 半角チェック
        hannkaku: value => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z\\+\\-\\/\\*\\,\\.]*$/
          return pattern.test(value) || '半角文字のみで入力してください。'
        },
        // 半角カナ
        hanKana: value => {
          if (!value) {
            return true;
          }
          const pattern = /^[ｦ-ﾟ]*$/
          return pattern.test(value) || '半角カナのみで入力してください。'
        },
        // 半角英数チェック
        hanAlpha: value => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z]*$/
          return pattern.test(value) || '半角英数字のみで入力してください。'
        },
        // 整数数値チェック
        integer: value => {
          if (!value) {
            return true;
          }
          const pattern = /^[+,-]?\d*$/
          return pattern.test(value) || '整数のみで入力してください。'
        },
        // 整数数値チェック（MIN、MAX)
        integerMax99: value => {
          if (!value) {
            return true;
          }
          return value && value <= 99 || '99以下の整数数値で入力してください。'
        },
        integerMin99: value => {
          if (!value) {
            return true;
          }
          return value && value >= 0 || '0以上の整数数値で入力してください。'
        },
        // 数値チェック
        number: value => {
          if (!value) {
            return true;
          }
          const pattern = /^-?([1-9][0-9]*|0)(\.[0-9]+)?$/
          return pattern.test(value) || '数値のみで入力してください。'
        },
        // 電話番号
        number2: value => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]*)(-[0-9]+)?(-[0-9]+)?$/
          return pattern.test(value) || '電話番号で入力してください。'
        },
        // 数値チェック
        number3: value => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]*|0)$/
          return pattern.test(value) || '数値のみで入力してください。'
        },
        // 数値チェック（MIN、MAX)
        numberMax99: value => {
          if (!value) {
            return true;
          }
          return value && value <= 99.9 || '99以下の数値で入力してください。'
        },
        numberMax100: value => {
          if (!value) {
            return true;
          }
          return value && value < 100 || '99.99以下の数値で入力してください。'
        },
        numberMax100_point_999: value => {
          if (!value) {
            return true;
          }
          return value && value < 100 || '99.999以下の数値で入力してください。'
        },
        numberMax10000: value => {
          if (!value) {
            return true;
          }
          return value && value < 10000 || '9999.99以下の数値で入力してください。'
            },
            numberMax1000: value => {
                if (!value) {
                    return true;
                }
                return value && value < 1000 || '999.99以下の数値で入力してください。'
            },
        numberMin99: value => {
          if (!value) {
            return true;
          }
          return value && value >= 0 || '0以上の数値で入力してください。'
        },
        numberMin1: value => {
          if (!value) {
            return true;
          }
          return value && value >= 1 || '1以上の数値で入力してください。'
        },
        // 金額チェック
        currency: value => {
          if (!value) {
            return true;
          }
          const pattern = /^([1-9]\d*|0)$/
          return pattern.test(value) || '整数で入力してください。'
        },
        number_point_2: value => {
          if (!value) {
            return true;
          }
          const pattern = /^((?!0[0-9])\d+(\.\d{1,2})?)$/
          return pattern.test(value) || '整数または小数点以下の二桁で入力してください。'
        },
        number_point_3: value => {
          if (!value) {
            return true;
          }
          const pattern = /^((?!0[0-9])\d+(\.\d{1,3})?)$/
          return pattern.test(value) || '整数または小数点以下の三桁で入力してください。'
        },
        // 階数チェック
        numbercuurency: value => {
          if (!value) {
            return true;
          }
          const pattern = /^([1-9]\d*|0)$/
          return pattern.test(value) || '1以上の数値で入力してください。'
            },
            //数値チェック（メータ値）
            meterVal: value => {
                const pattern = /^([1-9][0-9]{0,5}|0)(\.[0-9]{0,3})?$/
                return pattern.test(value) || '整数部６桁以下、小数部３桁以下で入力してください。'
            },
            //数値チェック（使用量）
            useAmount: value => {
                const pattern = /^([1-9][0-9]{0,6}|0)(\.[0-9]{0,3})?$/
                return pattern.test(value) || '整数部7桁以下、小数部３桁以下で入力してください。'
            },
        // 外字チェック（特殊文字禁止）
        spec: value => {
          if (!value) {
            return true;
          }
          var iChars = "~`!#$%^&*+=-[]\\;,/{}|\":<>?";
          var checkFlag = false;
          for (var i = 0; i < value.length; i++) {
            if (iChars.indexOf(value.charAt(i)) != -1) {
              checkFlag = true;
              break;
            }
          }
          return !checkFlag || '特殊文字禁止が含まれています。'
        }
      },
    };
  }
})

new Vue({
  router,
  store,
  vuetify,
  cognito,
  render: h => h(App)
}).$mount('#app')